import { createId } from "../utils/string";

const sideMapping = {
  front: 0,
  back: 1,
  both: 2,
};

export default {
  name: "material",
  render(h) {
    return h(
      "div",
      this.$scopedSlots.default ? this.$scopedSlots.default({}) : []
    );
  },
  provide() {
    return {
      material: this.toProvide,
    };
  },
  inject: {
    bimface: {
      default: {
        materialContainer: null,
      },
    },
    model: {
      default: {
        model3D: null,
      },
    },
  },
  props: {
    id: [String, Number],
    offset: Array,
    reverse: {
      type: Boolean,
      default: false,
    },
    rotation: Number,
    scale: Array,
    side: {
      type: String,
      default: "front",
      validator: function (value) {
        return ["front", "back", "both"].includes(value);
      },
    },
    src: String,
    textureType: {
      type: String,
      default: "image",
      validator: function (value) {
        return ["image", "video"].includes(value);
      },
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      materialContainer: null,
      objIds: new Set(),
      instance: null,
      toProvide: {
        comp: null,
        instance: null,
      },
    };
  },
  computed: {
    viewer3D() {
      return this.bimface.viewer3D;
    },
    model3D() {
      return this.model.model3D;
    },
  },
  watch: {
    "bimface.materialContainer": function (newVal) {
      this.materialContainer = newVal;
      this.init(newVal, this.viewer3D);
    },
    rotation(newVal) {
      this.instance && this.instance.setRotation(newVal);
    },
    scale(newVal) {
      this.instance && this.instance.setScale(newVal);
    },
    src(newVal) {
      this.instance && this.instance.setSrc(newVal);
    },
    offset(newVal) {
      this.instance && this.instance.setOffset(newVal);
    },
    reverse(newVal) {
      this.instance && newVal && this.instance.reverse();
    },
  },
  methods: {
    init(materialContainer, viewer3D) {
      let config = new Glodon.Bimface.Plugins.Material.MaterialConfig();
      this.offset && (config.offset = this.offset);
      this.reverse && (config.reverse = this.reverse);
      this.rotation && (config.rotation = this.rotation);
      this.scale && (config.scale = this.scale);
      this.src && (config.src = this.src);
      this.side && (config.side = sideMapping[this.side]);
      this.textureType && (config.textureType = this.textureType);
      this.transparent && (config.transparent = this.transparent);

      config.viewer = viewer3D;
      config.id = this.id || createId();

      this.instance = new Glodon.Bimface.Plugins.Material.Material(config);
      materialContainer.addMaterial(this.instance);
      this.toProvide.comp = this;
      this.toProvide.instance = this.instance;
    },
    addModelComponent(objId) {
      this.objIds.add(objId);
      this.instance &&
        this.instance.overrideComponentsMaterialById([...this.objIds.values()]);
    },
    removeModelComponent(objId) {
      this.objIds.delete(objId);
      this.instance &&
        this.instance.overrideComponentsMaterialById([...this.objIds.values()]);
    },
  },
};
